import FaqBlock from './components/FaqBlock.js';

/**
 * Instantiate a FaqBlock for each FAQ block.
 *
 * @param {boolean}                loop Wait for the questions to load, checking again every 500ms.
 * @param {Document|HTMLElement}   root Where to look for FAQ blocks: the page, or one block's wrapper in the editor.
 */
export function loadFAQBlocks( loop, root = document ) {
	// Make sure all content is loaded in the backend before trying to run the script, otherwise wait and do it again.
	const faqItem = root.querySelector( '.question-list__item' );

	if ( loop && ! faqItem ) {
		setTimeout( () => loadFAQBlocks( true, root ), 500 );
		return;
	}

	// Fetch all FAQ blocks and instantiate a FaqBlock class for each of them.
	const faqContainers = root.querySelectorAll( '.wp-block-qala-blocks-faq-block' );

	faqContainers.forEach( faqContainer => {
		new FaqBlock( faqContainer );
	} );
}

loadFAQBlocks();
